import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=a18fe916&scoped=true"
import script from "./Payments.vue?vue&type=script&lang=ts"
export * from "./Payments.vue?vue&type=script&lang=ts"
import style0 from "./Payments.vue?vue&type=style&index=0&id=a18fe916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18fe916",
  null
  
)

export default component.exports